export const DRAWER_TYPES = {
  REGISTER: "register",
  LOGIN: "login",
  FILTERS: "filters",
  MENU: "menu",
  NOTIFICATIONS: "notifications",
};
